const delRouteMessage = (state) => (route) => ({
  ...state,
  routeMessages: state.routeMessages.filter(({ route: r }) => route !== r),
});

export default delRouteMessage;
